/**
 * FeaturedDossiersGrid — "Featured Investigations" (living-archive redesign).
 * Keeps the cinematic dossier-card style: 1 primary centerpiece + 2 secondary.
 * Secondary cards swipe horizontally on mobile, grid on desktop.
 */
import React from "react";
import DossierCard from "./DossierCard";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useArchiveStats } from "../../hooks/useArchiveStats";
import { SectionHeader } from "./homeShared";

const FeaturedDossiersGrid = ({ featured = [] }) => {
  const stats = useArchiveStats();
  const seeAll = stats?.published_dossiers
    ? `See all ${stats.published_dossiers} dossiers` : "See all dossiers";
  if (!featured.length) return null;
  const [primary, ...rest] = featured;
  const secondary = rest.slice(0, 2);

  return (
    <section
      data-testid="home-featured-grid"
      className="relative"
      style={{ background: "#0B0A0D" }}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-20">
        <SectionHeader
          file="File 002 · Curated Investigations"
          title="Featured Investigations"
          subtitle="Hand-picked case files — source-backed, cross-referenced, and continuously updated by editorial."
          action="/archive"
          actionLabel={seeAll}
          testid="featured-header"
        />

        <div data-testid="featured-primary">
          <DossierCard dossier={primary} variant="featured" eager />
        </div>

        {/* Secondary — swipeable on mobile, side-by-side on desktop */}
        <div
          className="mt-5 flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2 -mx-4 px-4
                     md:mx-0 md:px-0 md:grid md:grid-cols-2 md:gap-5 md:overflow-visible
                     [scrollbar-width:thin] [scrollbar-color:#2D2A26_transparent]"
        >
          {secondary.map((d) => (
            <div key={d.slug} className="snap-start shrink-0 w-[82%] sm:w-[60%] md:w-auto">
              <DossierCard dossier={d} />
            </div>
          ))}
        </div>

        <div className="md:hidden mt-8">
          <Link
            to="/archive"
            data-testid="featured-see-all-mobile"
            className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.4em]
                       text-[#A39E93] hover:text-[#E4DFD3] transition-colors border-b border-[#454038] pb-1"
          >
            {seeAll} <ArrowRight size={12} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedDossiersGrid;
